export default __webpack_public_path__ + "static/media/cat3.fdd00eef.png";